/**
 * Angular dependencies
 */
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Third-party dependencies
 */
import { AutosizeModule } from 'ngx-autosize';

/**
 * App dependencies
 */
import { AlertComponent } from '@app/alert/alert/alert.component';
import { KomodoModule } from '@app/core/modules/komodo/komodo.module';
import { SafePipe } from '@app/core/pipe/safe.pipe';
import { ShortNumberPipe } from '@app/core/pipe/short-number.pipe';
import { DrawerComponent } from '@app/drawer/drawer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CircleWithInitialsComponent } from "@shared/components/circle-with-initials/circle-with-initials.component";
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { ChipBoxComponent } from './components/chip-box/chip-box.component';
import { ChipComponent } from './components/chip/chip.component';
import { ClosableImageChipComponent } from './components/closable-image-chip/closable-image-chip.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { CountdownLabelComponent } from './components/countdown-label/countdown-label.component';
import { ExamplePromptComponent } from './components/example-prompt/example-prompt.component';
import { IconsModule } from './components/icons/icons.module';
import { LikesCountComponent } from './components/likes-count/likes-count.component';
import { NewsBannerComponent } from './components/news-banner/news-banner.component';
import { RetentionPolicyChipComponent } from './components/retention-policy-chip/retention-policy-chip.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { ClickOutsideDrawerDirective } from './directives/click-outside-drawer/click-outside-drawer.directive';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { DragAndDropDirective } from './directives/drag-and-drop/drag-and-drop.directive';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { NoSpacesDirective } from './directives/no-spaces/no-spaces.directive';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';
import { FormatUsernamePipe } from './pipes/format-username/format-username.pipe';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AlertComponent,
    ChipComponent,
    ChipBoxComponent,
    CircleWithInitialsComponent,
    ClickOutsideDirective,
    ClickOutsideDrawerDirective,
    ClosableImageChipComponent,
    ConfirmDialogComponent,
    ContextMenuComponent,
    CountdownLabelComponent,
    DragAndDropDirective,
    DrawerComponent,
    ExamplePromptComponent,
    FeatureFlagDirective,
    FormatUsernamePipe,
    LikesCountComponent,
    NewsBannerComponent,
    NoSpacesDirective,
    NotificationCardComponent,
    RetentionPolicyChipComponent,
    SafePipe,
    ShortNumberPipe,
    TooltipComponent,
    TooltipDirective,
  ],
  exports: [
    AlertComponent,
    AutosizeModule,
    ChipComponent,
    ChipBoxComponent,
    CircleWithInitialsComponent,
    ClickOutsideDirective,
    ClickOutsideDrawerDirective,
    ClosableImageChipComponent,
    ConfirmDialogComponent,
    ContextMenuComponent,
    CountdownLabelComponent,
    ExamplePromptComponent,
    DragAndDropDirective,
    DrawerComponent,
    FeatureFlagDirective,
    FontAwesomeModule,
    FormatUsernamePipe,
    IconsModule,
    KomodoModule,
    LikesCountComponent,
    NewsBannerComponent,
    NgOptimizedImage,
    NoSpacesDirective,
    NotificationCardComponent,
    RetentionPolicyChipComponent,
    SafePipe,
    ShortNumberPipe,
    TooltipComponent,
    TooltipDirective,
  ],
  imports: [
    AutosizeModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    IconsModule,
    KomodoModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    RouterModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule { }
